import styled from 'styled-components'

export const PageWrapper = styled.div``

export const PageTitle = styled.h3`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 16px;
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 24px;
  color: #999;
`

export const WorkerConfigInfo = styled.div`
  margin-top: 16px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 14px;
  
  strong {
    font-weight: 600;
    color: #333;
  }
`

